import { model as i18n } from '!/i18n'
import { formatCategoryWithChannelsToUi } from '$/tv/сhannels/lib'
import type { UiCategoryWithChannels } from '@/interfaces'
import { api } from '@setplex/tria-api'
import { combine, type Store } from 'effector'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'

export const $infiniteChannelsFormatted: Store<UiCategoryWithChannels | null> =
  combine(
    api.tv.$infiniteChannelsCategory,
    ssePurchasesModel.$channel,
    i18n.$t,
    (data, adjust, { t }) => formatCategoryWithChannelsToUi(data, adjust, t)
  )

export const $infiniteTvTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('all')
)
